import React from 'react';
import styled from 'styled-components';
import { COLOR_ACCENT, COLOR_ACCENT_DARK, COLOR_DESCRIPTION, DEVICES } from '../../const';
import ChannelTalkService from '../../ChannelTalkService';


const Container = styled.div`
  background-color: #fff;
  @media ${DEVICES.mobile} {
    padding: 40px 0;
  }

  @media ${DEVICES.tablet} {
    padding: 120px 0;
  }
`;

const Inner = styled.div`
  margin: auto;

  @media ${DEVICES.mobile} {
    display: block;
    text-align: center;
  }

  @media ${DEVICES.tablet} {
    display: flex;
    align-items: center;
    text-align: left;
  }

  @media ${DEVICES.large} {
    display: flex;
    max-width: 1200px;
    align-items: center;
  }
`;

const Left = styled.div`
  padding: 2rem;
  @media ${DEVICES.mobile} {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media ${DEVICES.tablet} {
    width: 50%;
  }

  @media ${DEVICES.large} {
    width: 50%;
  }
`;

const LeftImg = styled.img`
  width: 100%;
  border-radius: 20px;
`;

const Right = styled.div`
  padding: 2rem;
  @media ${DEVICES.mobile} {
  }

  @media ${DEVICES.tablet} {
    width: 50%;
  }

  @media ${DEVICES.large} {
    width: 50%;
  }
`;

const RightHeading = styled.div`
`;

const RightTitle = styled.div`
  font-weight: 700;
  margin-top: 1rem;
  line-height: 1.3;

  @media ${DEVICES.mobile} {
    font-size: 1.8rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 1.5rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 1.8rem;
  }
`;

const RightDescription = styled.div`
  margin-top: 2rem;
  color: ${COLOR_DESCRIPTION};
  @media ${DEVICES.mobile} {
    font-size: 1rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 0.8rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 1rem;
  }
`;

const ContactButton = styled.button`
  border-radius: 1rem;
  padding: 1rem 3rem;
  text-align: center;
  background-color: ${COLOR_ACCENT_DARK};
  color: #fff;
  margin-top: 2rem;
  border: 0;
  font-weight: 600;
  cursor: pointer;
  font-size: 1rem;

  @media ${DEVICES.mobile} {
    min-width: 240px;
  }

  @media ${DEVICES.tablet} {
    min-width: 240px;
  }

  @media ${DEVICES.laptop} {
    min-width: 280px;
  }

  &:hover {
    background-color: ${COLOR_ACCENT};
  }
`;

export default function ContactBanner() {

  const openChannelTalk = () => {
    ChannelTalkService.openChat();
  };

  return (
    <Container>
      <Inner>
        <Left>
          <LeftImg src="https://kangaroo-edu-main.s3.ap-northeast-2.amazonaws.com/landing-page/home/contact.jpg" />
        </Left>
        <Right>
          <RightTitle>
            아이에게 <br />
            운동을 평생 습관으로 <br />
            선물하고 싶다면
          </RightTitle>
          <RightDescription>
            캥거루짐이 돕겠습니다 <br />
            우리의 자식이라는 마음으로 <br />
            아이들을 대하겠습니다
          </RightDescription>
          <ContactButton onClick={openChannelTalk}>
            지금 상담 신청하기
          </ContactButton>
        </Right>
      </Inner>
    </Container>
  )
}
